import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const farmRoomsList = createAsyncThunk('farmRoomsList', async ({ navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'rooms',
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const farmRoomsListSlice = createSlice({
    name: 'farmRoomsList',
    initialState: {
        data: [],
    },
    reducers: {
        clearFarmRoomsList: (state) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(farmRoomsList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const payloadData = action.payload.data.data;
                state.data = payloadData?.rows ?? payloadData ?? [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(farmRoomsList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { clearFarmRoomsList } = farmRoomsListSlice.actions;
export default farmRoomsListSlice.reducer;
